var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{ref:"chart",staticClass:"hc",staticStyle:{"min-width":"310px","max-width":"100%","margin":"auto","display":"flex","justify-content":"center"},attrs:{"constructorType":'mapChart',"options":_vm.getOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }